import React, { Component } from "react";
import axios from "axios";
import styles from "./styles/ViewTalent.scss";
import BackToDashboard from './BackToDashboard';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export default class ViewMyInvites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectors: [],
      nominees: []
    };
  }

  componentDidMount = () => {
    axios
      .post("/api/kingstonconnect/getallnominees/")
      .then(res => {
        this.setState({ nominees: res.data });
        return Promise.resolve(1);
      })
      .catch(e => {
        this.setState({ error_saving: true, saved_recently: false });
        console.log(e);
      });
  };

  handleSectorSelect = e => {
    this.setState({
      sectors: e
    });
  };

  back = () => {
    window.history.back();
  }

  resend = (id) => {
    this.setState({ resending: id })
    axios
      .post("/api/kingstonconnect/resendinvite/",
        {"_id" : id})
      .then(res => {
        this.setState({ resending: undefined })
      })
      .catch(e => {
        // We should probably add
        // something here to say it failed
        this.setState({ resending: undefined })
      });
  }

  render() {
    return (
      <div className={styles.page}>
        <h1>My <strong>Kingston<span style={{color: '#007D99'}}>Connect</span></strong> Invites</h1>
        <BackToDashboard/>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">First</th>
              <th scope="col">Last</th>
              <th scope="col">Email</th>
              <th scope="col">Nomination Date</th>
              <th scope="col">Accepted</th>
            </tr>
          </thead>
          <tbody>
            {this.state.nominees.map(n => {
              let row = (
                <tr>
                  <td>{n.first_name}</td>
                  <td>{n.last_name}</td>
                  <td>{n.email}</td>
                  <td>{n.nomination_date}</td>
                  <td>
                    {n.update_date ? (
                      "Accepted"
                    ) : (
                      <button className="btn btn-primary"
                      onClick={() => this.resend(n._id)}>
                        {"Resend "}
                        {this.state.resending === n._id &&
                          <FontAwesomeIcon spin
                          icon={faSpinner}
                          />
                        }
                      </button>
                    )}
                  </td>
                </tr>
              );
              if (n.nominator === sessionStorage.getItem("employer")) {
                // change to logged in user _id
                return row;
              }
              return [];
            })}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/ViewMyInvites.js